import React from "react";
import { withTranslation } from "react-i18next";
import { Button, Form, InputGroup } from "react-bootstrap";
import ValidationHelper from "../../../../../helpers/ValidationHelper";
import {
  faTimes,
  faEdit,
  faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TabSection from "../tabSection/TabSection";
import SEBSettingsSection from "../generalSections/sebSettingsSection/SEBSettingsSection";
import equals from "fast-deep-equal";


class WebConfiguration extends React.Component {
  constructor(props) {
    super(props);
    this.fileReader = new FileReader();
    this.validationDefinition = this.getValidation();

    this.state = {
      validation: ValidationHelper.getValidation(this.validationDefinition),
      isInvalidSEBConfiguration: false,
      editLMSExaminationKey: false,
      useOwnSEBTemplate:
        ValidationHelper.isFieldDefined(
          this.props.configuration,
          "seb_configuration"
        ) && this.props.configuration.seb_configuration.length > 0,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleReadData = this.handleReadData.bind(this);
    this.getValidation = this.getValidation.bind(this);

    this.fileReader.onload = this.handleReadData;
  }

  componentDidMount() {
    this.validationDefinition = this.getValidation();
    this.setState({
      validation: ValidationHelper.getValidation(this.validationDefinition)
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!equals(prevProps.configuration, this.props.configuration)) {
      this.validationDefinition = this.getValidation();
      this.setState({
        validation: ValidationHelper.getValidation(this.validationDefinition)
      })
    }
  }


  getValidation(){
    return {
      web_url: {
        defaultValue: ValidationHelper.isFieldDefined(
            this.props.configuration,
            "web_url"
        )
            ? this.props.configuration.web_url
            : "",
        initValid: true,
        rule: ValidationHelper.isUrl,
      },
      lms_examination_key: {
        defaultValue: ValidationHelper.isFieldDefined(
            this.props.configuration,
            "lms_examination_key"
        )
            ? this.props.configuration.lms_examination_key
            : "",
        initValid: true,
        rule: ValidationHelper.isSHA256,
      },
      seb_configuration: {
        defaultValue: ValidationHelper.isFieldDefined(
            this.props.configuration,
            "seb_configuration"
        )
            ? this.props.configuration.seb_configuration
            : "",
        initValid: true,
        rule: ValidationHelper.isString,
      },
      start_password: {
        defaultValue: ValidationHelper.isFieldDefined(
            this.props.configuration,
            "start_password"
        )
            ? this.props.configuration.start_password
            : "",
        initValid: true,
        rule: ValidationHelper.isString,
      },
      quit_password: {
        defaultValue:
            ValidationHelper.isFieldDefined(
                this.props.configuration,
                "quit_password"
            ) && this.props.configuration.quit_password.length > 0
                ? this.props.configuration.quit_password
                : (Math.random() + 1).toString(36).substring(8),
        initValid: true,
        rule: (value) => ValidationHelper.isString(value) && value.length > 0,
      }
    };
  }

  async handleReadData() {
    const xmlStartSequence = "<?xml";
    this.setState({ isInvalidSEBConfiguration: false });
    try {
      const resource = await fetch(this.fileReader.result);
      const dataBlob = await resource.blob();
      const gzipBlob = dataBlob.slice();
      let possibleXMLSEBConfiguration = await dataBlob.text();
      if (possibleXMLSEBConfiguration.substring(0, 5) !== xmlStartSequence) {
        // It is not plain text -> Gzip compressed
        //eslint-disable-next-line
        const ds = new DecompressionStream("gzip");
        const decompressedStream = gzipBlob.stream().pipeThrough(ds);
        const responseBlob = await new Response(decompressedStream).blob();
        possibleXMLSEBConfiguration = await responseBlob.text();
        if (possibleXMLSEBConfiguration.substring(0, 5) !== xmlStartSequence) {
          this.setState({ isInvalidSEBConfiguration: true });
          return;
        }
      }
      this.setState({ isInvalidSEBConfiguration: false });
      this.handleChange({
        target: {
          name: "seb_configuration",
          value: btoa(possibleXMLSEBConfiguration),
        },
      });
      return;
    } catch (err) {
      console.error(err);
    }
    this.setState({ isInvalidSEBConfiguration: true });
  }

  handleUpload(event) {
    this.fileReader.readAsDataURL(event.target.files[0]);
  }

  handleChange(event) {
    this.setState({
      validation: ValidationHelper.update(event, this.state.validation),
    }, () =>{
      if (this.state.validation._isValid) {
        this.props.onUpdate(ValidationHelper.getData(this.state.validation));
      }
      this.props.onValid(this.state.validation._isValid);
    });
  }

  handleUpdate(remoteUpdate){
    const currentUpdate = ValidationHelper.getData(this.state.validation);
    const mergedUpdate = Object.assign( {}, currentUpdate, remoteUpdate);
    ValidationHelper.setData(this.state.validation, mergedUpdate);
    this.props.onUpdate(mergedUpdate);
  }

  render() {
    const { t } = this.props;
    return (
      <>
        <TabSection
            openbydefault={true}
            title={t("SingleExamination.ConfigurationTab.VmConfiguration.GeneralConf")}
        >
          <Form.Group controlId="formWebUrl">
            <Form.Label>
              {t(
                  "SingleExamination.ConfigurationTab.WebConfiguration.WebUrl"
              )}
            </Form.Label>
            <Form.Control
                type="text"
                name="web_url"
                disabled={this.props.disabled}
                value={this.state.validation.web_url.value}
                isInvalid={!this.state.validation.web_url.isValid}
                onChange={this.handleChange}
            />
            <Form.Control.Feedback type="invalid">
              {t(
                  "SingleExamination.ConfigurationTab.WebConfiguration.ValidationError.WebUrl"
              )}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group
              controlId="formStartPassword"
          >
            <Form.Label>
              {t("SingleExamination.ConfigurationTab.WebConfiguration.StartPassword")}
            </Form.Label>
            <Form.Control
                type="text"
                name="start_password"
                disabled={
                  this.props.examination.status !== 1 &&
                  this.props.examination.status !== 50 &&
                  this.props.examination.status !== 51 &&
                  this.props.examination.status !== 52 &&
                  this.props.examination.status !== 53
                }
                value={this.state.validation.start_password.value}
                isInvalid={!this.state.validation.start_password.isValid}
                onChange={this.handleChange}
            />
            {this.state.validation.start_password.value.length < 1 ? (
                <Form.Text className="color-yellow">
                  <FontAwesomeIcon icon={faExclamationTriangle} />{" "}
                  {t("SingleExamination.ConfigurationTab.WebConfiguration.WarningNoStartPassword")}
                </Form.Text>
            ) : (
                ""
            )}
            <Form.Control.Feedback type="invalid">
              {t(
                  "SingleExamination.ConfigurationTab.WebConfiguration.ValidationError.StartPassword"
              )}
            </Form.Control.Feedback>
          </Form.Group>
          {this.props.securityLevel >= 1 && this.props.securityLevel <= 4 ? (
              <Form.Group controlId="formLMSExaminationKey">
                <Form.Label>
                  {t(
                      "SingleExamination.ConfigurationTab.WebConfiguration.LMSExaminationKey"
                  )}
                </Form.Label>
                <InputGroup>
                  <Form.Control
                      type="text"
                      name="lms_examination_key"
                      disabled={
                        this.props.disabled || !this.state.editLMSExaminationKey
                      }
                      readOnly={!this.state.editLMSExaminationKey}
                      value={this.state.validation.lms_examination_key.value}
                      isInvalid={!this.state.validation.lms_examination_key.isValid}
                      onChange={this.handleChange}
                  />
                  <Button
                      onClick={() =>
                          this.setState({
                            editLMSExaminationKey: !this.state.editLMSExaminationKey,
                          })
                      }
                      className="btn btn-black"
                      disabled={this.props.disabled}
                      style={{
                        borderBottomLeftRadius: "0px",
                        borderTopLeftRadius: "0px",
                      }}
                  >
                    {this.state.editLMSExaminationKey ? (
                        <FontAwesomeIcon icon={faTimes} />
                    ) : (
                        <FontAwesomeIcon icon={faEdit} />
                    )}
                  </Button>
                </InputGroup>
                <Form.Control.Feedback type="invalid">
                  {t(
                      "SingleExamination.ConfigurationTab.WebConfiguration.ValidationError.LMSExaminationKey"
                  )}
                </Form.Control.Feedback>
              </Form.Group>
          ) : ""}
        </TabSection>

        {this.props.securityLevel === 5 || this.props.securityLevel ===6 ? (
            <TabSection
                title={t("SingleExamination.ConfigurationTab.VmConfiguration.SEBConf")}
                description={t("SingleExamination.ConfigurationTab.VmConfiguration.SEBDescription")}
                bottomDivider={false}
            >
              <SEBSettingsSection
                  disabled={
                    this.props.examination.status !== 1 &&
                    this.props.examination.status !== 50 &&
                    this.props.examination.status !== 51 &&
                    this.props.examination.status !== 52 &&
                    this.props.examination.status !== 53
                  }
                  onUpdate={this.handleUpdate}
                  onSEBConfigurationDownload={this.props.onSEBConfigurationDownload}
                  onValid={this.props.onValid}
                  isDirty={this.props.isDirty}
                  securityLevel={this.props.examination.securityLevel}
                  configuration={this.props.configuration}
                  validation={this.state.validation}
              />
            </TabSection>
        ) : ""}
      </>
    );
  }
}

export default withTranslation()(WebConfiguration);
